<template>
  <v-card
    v-resize="onResize"
    @drop.prevent="
      $security.checkUserAccess('UploadDocument')
        ? selectedNode && onDrop($event)
        : ''
    "
    @dragover.prevent="
      $security.checkUserAccess('UploadDocument')
        ? selectedNode
          ? (dragover = true)
          : ''
        : ''
    "
    @dragenter.prevent="
      $security.checkUserAccess('UploadDocument')
        ? selectedNode
          ? (dragover = true)
          : ''
        : ''
    "
    :class="{ dragover: dragover }"
    class="document-drag-drop-container px-4"
    elevation="0"
  >
    <v-card-text v-if="dragover" class="document-drag-drop-box">
      <v-row class="d-flex flex-column" dense align="center" justify="center">
        <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
          mdi-cloud-upload
        </v-icon>
        <p style="color: #000000">{{ $t("documents.msgDragDropFiles") }}</p>
      </v-row>
    </v-card-text>
    <div class="pr-2">
      <a-data-table
        v-model="selectedFiles"
        :headers="headers"
        :items="documentItems"
        :search="search"
        :custom-filter="customSearch"
        dense
        fixed-header
        show-select
        :height="screenHeight"
        :items-per-page="1000"
        hide-default-footer
        mobile-breakpoint="0"
        :no-data-text="$t('noData')"
        :no-results-text="$t('emptySearchRecords')"
        :sort-by="sortOnColumn"
        :sort-desc="sortType"
        :must-sort="true"
      >
        <template v-slot:[`item.name`]="{ item }">
          <span class="primary--text" v-if="item.type == 'directory'">
            <v-icon class="mr-3"> mdi-folder </v-icon> {{ item.name }}</span
          >
          <span class="primary--text" v-else>
            <v-icon class="mr-3">
              {{ fileIcons[item.file.toLowerCase()] }}
            </v-icon>
            <a
              v-if="$security.checkUserAccess('OpenDocument')"
              @click="onFileDownload(item)"
              >{{ item.fileName }}</a
            >
            <span v-else>{{ item.fileName }}</span>
          </span>
        </template>

        <template v-slot:[`item.datetime`]="{ item }">
          <p v-if="item.type == 'file'" class="subtitle-2 pa-0 ma-0">
            {{ getDate(item.datetime) }}
          </p>
        </template>
      </a-data-table>
    </div>
  </v-card>
</template>

<script>
import FileInput from "@/wrapper-component/FileInput.vue";
import { mapActions, mapGetters } from "vuex";
import { MAX_UPLOAD_SIZE, fileIcons } from "../../utils/constant";
import {
  formatBytes,
  openDocument,
  isoIntlDateFormat,
} from "../../utils/util";
import _ from "lodash";

export default {
  name: "DocumentDetailListView",
  components: { FileInput },
  props: {
    files: Array,
    search: String,
    selectionClear: Boolean,
    accept: Array,
    selectedNode: {
      type: Object,
      default: null,
    },
    defaultSortOrder: {
      type: Object,
      default: () => ({ sortOnColumn: "datetime", sortType: "desc" }),
    },
  },
  data() {
    return {
      screenHeight: 0,
      dragover: false,
      uploadedFiles: [],
      selectedFiles: [],
      maxsize: MAX_UPLOAD_SIZE,
      fileIcons: fileIcons,
      fileList: [
        {
          name: "static",
          modified: "2021-07-17 09:10",
          children: [
            {
              name: "logo.png",
              file: "png",
              modified: "2021-07-17 09:10",
              size: "87 KB",
            },
          ],
        },
        {
          name: "favicon.ico",
          file: "png",
          modified: "2021-07-17 09:10",
          size: "100 KB",
        },
        {
          name: "index.html",
          file: "html",
          modified: "2021-07-17 09:10",
          size: "112 KB",
        },
      ],
      fileList1: [],

      filesExts: {
        html: "mdi-language-html5",
        js: "mdi-nodejs",
        json: "mdi-code-json",
        md: "mdi-language-markdown",
        pdf: "mdi-file-pdf-box",
        png: "mdi-file-image",
        txt: "mdi-file-document-outline",
        xls: "mdi-file-excel",
      },
    };
  },
  watch: {
    selectionClear(val) {
      this.selectedFiles = [];
    },
    selectedFiles() {
      this.onSelection();
    },
  },
  computed: {
    ...mapGetters({
      tenantSettingConfig: "tenant/tenantSettingConfig",
    }),
    sortOnColumn() {
      if (this.defaultSortOrder) {
        return this.defaultSortOrder.sortOnColumn;
      }
      return "datetime";
    },
    sortType() {
      if (this.defaultSortOrder) {
        return this.defaultSortOrder.sortType === "desc";
      }
      return true;
    },
    documentItems() {
      const documentList = [];
      this.files.forEach((document) => {
        if (document.type === "directory") {
          documentList.push({
            ...document,
          });
        } else {
          documentList.push({
            ...document,
            name: document.fileName,
            datetime: document.uploaded_at || document._ts,
          });
        }
      });
      return documentList;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    checkedFiles() {
      return this.selectedFiles;
    },
    headers() {
      return [
        {
          text: this.$t("lblSearchTextDocumentFolder"),
          align: "left",
          value: "name",
          class: "header header-text",
        },
        {
          text: this.$t("documents.lblUploadTime"),
          align: "left",
          value: "datetime",
          class: "header header-text",
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      downloadDocumentAPI: "document/downloadDocument",
    }),
    customSorting(items, sortBy, sortDesc) {
      if (sortBy[0] === "datetime" && Boolean(sortDesc)) {
        return _.orderBy(
          items,
          [sortBy[0]],
          [sortDesc[0] ? "desc" : "asc", "asc"]
        );
      }
      if (sortBy[0] === "name") {
        const sItems = items.sort((a, b) => {
          const nameA = a.fileName || a.name;
          const nameB = b.fileName || b.name;

          if (nameA.toLowerCase() === nameB.toLowerCase()) {
            if (nameA === nameB) return 0;
            return nameA < nameB ? -1 : 1; // Uppercase after lowercase
          }
          return nameA.toLowerCase() < nameB.toLowerCase() ? -1 : 1;
        });

        return sortDesc[0] ? sItems.reverse() : sItems;
      }
      return items;
    },
    getDate(date) {
      return isoIntlDateFormat(this.$i18n.locale, date);
    },
    customSearch(val, search, i) {
      if (i.type == "file") {
        return (
          i.fileName.toLowerCase().includes(search) ||
          i.fileName.toUpperCase().includes(search)
        );
      } else if (i.type == "directory") {
        return (
          i.name.toLowerCase().includes(search) ||
          i.name.toUpperCase().includes(search)
        );
      }
      return false;
    },
    onResize() {
      this.screenHeight = window.innerHeight - 320;
    },
    close() {
      this.$emit("close");
    },
    onSelection() {
      this.$emit("onSelection", this.selectedFiles);
    },
    async onFileDownload(file) {
      const params = {
        documentId: file.id,
        filename: file.fileName,
      };
      const res = await this.downloadDocumentAPI(params);
      let contentType = res.headers["content-type"];
      let blob = new Blob([res.data], { type: contentType });
      let url = window.URL.createObjectURL(blob);
      openDocument(url, file.fileName);
    },
    onDrop(e) {
      this.dragover = false;
      let files = e.target.files || e.dataTransfer.files;
      const maxSize = this.maxsize ?? 0;
      const uploadedFiles = [];
      const filesWithStatus = [];
      Array.from(files).forEach((file) => {
        if (!this.accept.includes(file.type)) {
          filesWithStatus.push({
            filename: file.name,
            status: false,
            message: this.$t("fileErrorMsg", { filename: file.name }),
          });
        } else if (file.size > maxSize) {
          filesWithStatus.push({
            filename: file.name,
            status: false,
            message: this.$t("fileSizeErrorMsg", {
              maxsize: formatBytes(maxSize),
            }),
          });
        } else {
          uploadedFiles.push(file);
          filesWithStatus.push({
            filename: file.name,
            status: true,
            message: this.$t("fileErrorMsg", { filename: file.name }),
          });
        }
      });
      this.$emit("add-files", files);
    },
  },
};
</script>

<style scoped>
.v-application .subtitle-2 {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: var(--v-darkCharcoal-base) !important;
  line-height: 21px !important;
  font-family: "Noto Sans JP" !important;
}
.document-drag-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 400px;
}
.document-drag-box {
  border: 2px dashed #eee;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background-color: #ccc;
  z-index: 9999;
}
::v-deep thead th {
  padding: 4px 12px !important;
}
::v-deep tbody tr {
  height: 20px !important;
}
::v-deep tbody td {
  max-height: 48px !important;
  height: 20px !important;
  border-bottom: none !important;
  padding: 5px 12px !important;
}
::v-deep th {
  background: var(--v-neutralGray-base) !important;
  padding: 0 5px !important;
}
::v-deep .v-input--selection-controls__ripple {
  border-radius: unset !important;
  height: unset !important;
  width: unset !important;
}

::v-deep .v-simple-checkbox .v-icon {
  cursor: pointer;
}
.document-drag-drop-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.document-drag-drop-box {
  position: absolute;
  width: 95% !important;
  height: 100%;
  min-height: 300px;
  border: 2px dashed #eee;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ccc;
  opacity: 0.6;
}

.v-data-table__wrapper > table > tbody > tr > td:last-child,
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:last-child {
  border-bottom: none !important;
}
</style>
